import React from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { parseFilterValue } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/filter/parser';
import { boxShadowParsedValueToString } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/shadow/parser';
import { GlobalDesignActionLobbyItem } from '../types';
import { LobbyItemLayout } from '../common/lobby/LobbyItemLayout';
import BoxShadowPreview from '../controls/GroupPreview/BoxShadowPreview/BoxShadowPreview';
import { useGroupsPreviewPS } from '../common/lobby/useGroupsPreviewPS';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import { GD_WDS_EXPERIMENT } from '../experiments';
import { getCurrentDecomposedValues } from '../common/abstractStyles/decompositionUtils';

const FilterLobbyItem: GlobalDesignActionLobbyItem = (props) => {
  const { experiments } = useExperiments({ readOnly: true });
  const isWDS = experiments.enabled(GD_WDS_EXPERIMENT);

  // Always call hook with 'shadowStyles' action name (same as old PS code)
  const renderGroupPreviewPS = useGroupsPreviewPS(
    StylesDerivedNativeActions.shadowStyles,
    props.group,
  );

  const values = props.group.engine?.getAllValues() || null;

  const currentDecomposed = getCurrentDecomposedValues(values);

  const value = currentDecomposed.filter?.[0]?.resolvedValue || '';

  const mixedState = currentDecomposed.filter
    ? currentDecomposed.filter.reduce(
        (acc, curr) => {
          if (acc.isMixed) {
            return acc;
          }

          if (acc.prevValue && curr.resolvedValue !== acc.prevValue) {
            return { ...acc, isMixed: true };
          }

          return { ...acc, prevValue: curr.resolvedValue, isMixed: false };
        },
        {
          prevValue: '',
          isMixed: false,
        },
      )
    : { prevValue: '', isMixed: false };

  const parsedValue = value ? parseFilterValue(value).dropShadow : null;

  const mappedValue = parsedValue
    ? boxShadowParsedValueToString({
        blurRadius: parsedValue.blurRadius,
        color: parsedValue.color,
        offsetX: parsedValue.offsetX,
        offsetY: parsedValue.offsetY,
        inset: null,
        spreadRadius: null,
      })
    : '';

  if (!isWDS) {
    return (
      renderGroupPreviewPS({
        value: mappedValue,
        isMixed: mixedState.isMixed,
        emptyPreviewLabel:
          props.group.displayName.group || props.group.displayName.component,
        onClick: props.onSelect,
      }) ?? null
    );
  }

  return (
    <LobbyItemLayout
      actionName="shadowStyles"
      group={props.group}
      onSelect={props.onSelect}
    >
      <BoxShadowPreview
        value={mappedValue}
        isMixed={mixedState.isMixed}
        emptyPreviewLabel={
          props.group.displayName.group || props.group.displayName.component
        }
      />
    </LobbyItemLayout>
  );
};

export default FilterLobbyItem;
